import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

import { InicioRoutingModule } from './inicio-routing.module';
import { InicioComponent } from './inicio.component';
import { InicioBeneficiosComponent } from './inicio-beneficios/inicio-beneficios.component';
import { InicioCoberturaComponent } from './inicio-cobertura/inicio-cobertura.component';
import { InicioBannerComponent } from './inicio-banner/inicio-banner.component';
import { InicioServiciosComponent } from './inicio-servicios/inicio-servicios.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {RecaptchaModule} from 'ng-recaptcha';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    InicioComponent,
    InicioBannerComponent,
    InicioBeneficiosComponent,
    InicioServiciosComponent,
    InicioCoberturaComponent,
  ],
  imports: [
    InicioRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    RecaptchaModule,
    TranslateModule,
  ]
})
export class InicioModule { }
